var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v("翻新设备")]),_c('el-breadcrumb-item',[_vm._v("出售列表")])],1),_c('used-device-list',{attrs:{"status":100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }